import { OrangeKitWalletId } from "./types";
import XverseInjectedProvider from "./xverse/provider";
// eslint-disable-next-line import/prefer-default-export
export function getWalletInjectedProvider(walletId) {
    switch (walletId) {
        case OrangeKitWalletId.OKX: {
            return window?.okxwallet?.bitcoin;
        }
        case OrangeKitWalletId.UNISAT: {
            return window.unisat;
        }
        case OrangeKitWalletId.XVERSE: {
            const xverseProvider = window.XverseProviders?.BitcoinProvider;
            return xverseProvider ? new XverseInjectedProvider() : undefined;
        }
        default:
            throw new Error("Unknown wallet id: ", walletId);
    }
}
//# sourceMappingURL=utils.js.map